module.exports = __webpack_public_path__ + "img/JDE.31de7eb0.png";